/// <amd-module name="typeahead/core/util/PromiseTestUtil"/>

export class PromiseTestUtil {
    constructor() {
        //
    }
    public promiseCompleteUtil(data: any): void {
        // return data;
    }
}
